<!-- 
    * @Description: 嵌入大模型对话
    * @Version: 1.0
    * @Author: Junjie 
    * @Date: 2025-03-04 11:11:47 
    * @Last Modified by: Junjie
    * @Last Modified time: 2025-03-04 11:12:18
  -->
<template>
  <a-drawer
    :bodyStyle="{
        height: 'calc(100% - 55px)',
        overflow: 'auto',
        padding: 0
    }"
    :closable="false"
    :title="title"
    :visible="visible"
    :width="width"
    @close="close"
    destroyOnClose
    placement="right"
  >
    <iframe
      :src="localIframeSrc"
      allow="microphone"
      frameborder="0"
      style="width: 100%; height: 100%; min-height: 700px"
      v-if="!!localIframeSrc"
    ></iframe>

    <a-result
      status="404"
      sub-title="系统中没有找到AI助手相关的AGENT配置，请确认您已经部署了大模型并创建了AGENT应用，如果确认已部署请联系服务商配置。"
      title="未找到AI AGENT配置"
      v-else
    ></a-result>
  </a-drawer>
</template>

<script>
  import { httpAction, getAction } from '@/api/manage'

  import IframeFReportView from '@/components/layouts/IframeFReportView.vue';
  export default {
    name: 'EmbeddingDrawer',
    components: {
      IframeFReportView
    },
    // 添加 props 接收参数
    props: {
      title: {
        type: String,
        default: "详情"
      },
      width: {
        type: Number,
        default: 600
      },
      iframeSrc: {
        type: String,
        default: ''
      },
      allow: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        visible: false,
        // 创建一个本地数据属性来保存 iframeSrc 的值
        localIframeSrc: this.iframeSrc,
        url: {
          categoryList: "/custom/category/list"
        }
      }
    },
    created () {
      if (!this.localIframeSrc) {
        this.getAiAgentProps();
      }
    },
    methods: {
      getAiAgentProps () {
        getAction(this.url.categoryList, {
          cusProp1: 'aiAgent',
          enable: '1'
        }).then(res => {
          const props = res.result.records[0];
          if (props) {
            this.localIframeSrc = props.cusProp2;
          }
        })
      },
      show (src) {
        this.visible = true;
        this.localIframeSrc = src || this.localIframeSrc;
        if (!this.localIframeSrc) {
          this.getAiAgentProps();
        }
      },
      close () {
        this.$emit('close');
        this.visible = false;
        this.localIframeSrc = ''; // 释放 iframe 资源
      },
    }
  }
</script>

<style lang="less" scoped>
  /** Button按钮间距 */
  .ant-btn {
    margin-left: 30px;
    margin-bottom: 30px;
    float: right;
  }
  .drawer-footer {
    position: absolute;
    bottom: -8px;
    width: 100%;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    left: 0;
    background: #fff;
    border-radius: 0 0 2px 2px;
  }
</style>